// const POD_SETUPS = {
//     ELEC: {
//         WITHDRAWAL: [
//             ['TH'],
//             ['HI', 'LO'],
//             ['EX'],
//             ['TH', 'EX'],
//             ['HI', 'LO', 'EX'],
//             ['TH', 'HI', 'LO'],
//             ['TH', 'HI', 'LO', 'EX']
//         ],
//         INJECTION: [
//             [],
//             ['TH'],
//             ['HI', 'LO'],
//             ['EX'],
//             ['TH', 'EX'],
//             ['HI', 'LO', 'EX'],
//             ['TH', 'HI', 'LO'],
//             ['TH', 'HI', 'LO', 'EX']
//         ]
//     },
//     OTHER: {
//         WITHDRAWAL: ['TH'],
//         INJECTION: []
//     }
// }

// exports.POD_SETUPS = POD_SETUPS

const SCE_MAPPING = {
    "SCE_OFFTAKE": "Prélèvement",
    "SCE_INJECTI": "Injection",
    "SCE_COMOFFT": "Prélèvement compensé",
    "SCE_COMINJE": "Commercialisation de l'injection"
}

export const DIRECTION_MAPPING = {
    "prelevement": "Prélèvement",
    "injection": "Injection"
}

export const TIMEFRAME_FRIENDLY_MAPPING = {
    "TH": "Mono-horaire",
    "HI": "Heures pleines",
    "LO": "Heures creuses",
    "EX": "Exclusif nuit",
    "PK": "Heures pics",
    "MD": "Heures médiums",
    "EC": "Heures écos"
}

export function getSCEFriendlyName(sce) {
    const sceName = SCE_MAPPING[sce]
    return sceName ? sceName : sce
}